import { Injectable } from '@angular/core';
import { Angulartics2Module, Angulartics2, Angulartics2Segment } from 'angulartics2';
import { NewReportEvent } from '../models/new-report-event.model';

@Injectable()
export class EventsService {
    constructor(private angulartics2: Angulartics2Segment) {
    }

    recordReportCreatedEvent(newReportEvent: NewReportEvent) {
        newReportEvent.updateValuationFlagsForReport();
        this.recordEvent('New Report Created', newReportEvent);
    }

    recordDashboardLoadedEvent() {
        this.recordEvent('Dashboard Loaded', {description: 'The dashboard was successfully loaded', category: 'Dashboard'});
    }

    recordReportDownloadedEvent(reportTypeDownloaded: string) {
        this.recordEvent('Report Downloaded',
            {description: 'User downloaded a report', category: 'Report Summary', label: reportTypeDownloaded });
    }

    recordDiscrepanctReportDownloadedEvent() {
        this.recordEvent('Discrepancy Report Downloaded',
            {description: 'User downloaded a discrepancy report', category: 'Report Summary'});
    }

    recordReportArchivedEvent() {
        this.recordEvent('Report Archived', {description: 'User archived one or more reports', category: 'All Reports List'});
    }

    recordReportDeletedEvent() {
        this.recordEvent('Report Deleted', {description: 'User deleted one or more reports', category: 'All Reports List'});
    }

    recordReportRestoredEvent() {
        this.recordEvent('Report Restored',  {description: 'User restored one or more reports', category: 'All Reports List'});
    }

    recordGlobalSettingsChangedEvent(fieldsChanged: Array<string>) {

        fieldsChanged.forEach(f => {
            this.recordEvent('Global Setting Changed',
                { description: 'User changed global settings and clicked Save', category: 'Settings', label: f });
        });
    }

    recordAlternativeDerivativeSettingChangedEvent(newValue: string) {
        this.recordEvent('Global Setting Changed',
            { description: 'User changed global settings and clicked Save',
            category: 'Settings', label: 'Alternative Derivative', newAltDerivativeValue: newValue });
    }

    recordReportErrorScreenShownEvent()
    {
        this.recordEvent('Report Error Screen', {description: 'User was shown the Report Error screen', category: 'New Report'});
    }

    private recordEvent(eventName: string, eventArgs: object)
    {
        this.angulartics2.eventTrack(eventName, eventArgs);
    }
}


// WEBPACK FOOTER //
// ./src/app/events/services/events.service.ts